import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-right-sidebar-1-content-scroll',
    templateUrl  : './right-sidebar-1.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedRightSidebar1ContentScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
